module.exports = __webpack_public_path__ + "static/media/okr-logo.2c6bbeb2.svg";